

import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  DocumentsList,
  LogoLoader,
  Modal,
  StatusTags,
  TableAdv,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils/mapTableRows";
import { dateFormator } from "../../../../../utils/dateFormator";
import { visaData } from "../../../../../assets/data/candidatesData";
import { useDispatch, useSelector } from "react-redux";
import { getAllImmigrationsStart, getCurrentEmployeeImmigration } from "../../../../../redux/slices/immigration/immigrationSlice";
import { transformFiles } from "../../../../../utils/transformFiles";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { VisaType } from "../../../../../assets/data/enumData";

const Visa = ({onEdit}) => {
 const { page, limit, setPage, handleLimitChange } = usePagination(
       10,
       (newPage, newLimit) => {
         // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
       }
     );
   const dispatch = useDispatch();
    const { value } = useSelector(
       (state) => state.totalCount
     );
     const { loading,currentEmployeeImmigration } = useSelector(
       (state) => state.immigration
     );
      const totalCount = value?.cevisa?.data || 0
     const isLoading = loading;
   const lcaTableData= currentEmployeeImmigration?.visa||[]
  const [documentModal, setDocumentModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const handleclick = () => {
    setDocumentModal(!documentModal);
  };
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
  } = useSelector((state) => state.employee);
  const { immigrations: immigrationsTableData } = useSelector(
    (state) => state.immigration
  );
  const tableData =
    Array.isArray(immigrationsTableData?.data?.visa) &&
    immigrationsTableData.data.visa.length > 0
      ? immigrationsTableData?.data?.visa
      : [];
  const handelDocumetsModal = (documents) => {
    setDocumentModal(!documentModal);
    setSelectedDocuments(documents);
  };
  const columns = [
    {
      key: "type",
      label: "Visa Type",
      sortable: false,
      render:(row)=>{
        const findType = VisaType.find((data) => data.value === row?.type)?.label;
        return(
          <div>{findType || "Not Found"}</div>
        )
      }
    },
    {
      key: "issueDate",
      label: "Issue Date",
      render: (row) => {
        const { issueDate } = row?.approvalDetails || {};
        return dateFormator(issueDate, "month-day-year");
      },
      sortable: false,
    },
    {
      key: "expirationDate",
      label: "Expiration Date",
      render: (row) => {
        const { expiryDate } = row?.approvalDetails || {};
        return dateFormator(expiryDate, "month-day-year");
      },
      sortable: false,
    },
    {
      key: "petitionEndOn",
      label: "Petition End Date",
      render: (row) => dateFormator(row.petitionEndOn, "month-day-year"),
      sortable: false,
    },

    {
      key: "visaStatus",
      label: "Visa Status",
      render: (row) => <StatusTags tag={row?.visaStatus} />,
      sortable: false,
    },

    {
      key: "documents",
      label: "Documents",
      render: (row) => {
        const documents = transformFiles(
          row?.approvalDetails?.attachments || []
        );
        return (
          <div
            className={`flex items-center gap-1 flex-row ${
              documents.length > 0 && "cursor-pointer"
            }`}
            onClick={
              documents.length > 0
                ? () => handelDocumetsModal(documents)
                : () => {}
            }
          >
            <span className={`${documents.length > 0 && "text-linkblue"}`}>
              {documents.length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
      sortable: false,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => <StatusTags tag={row.status===1?"Active":"Inactive"} />,
      sortable: false,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit_square"
          size="xs"
          color="black"
          onClick={() => {onEdit(row)}}
        />
      ),
      sortable: false,
    },
  ];
  useEffect(() => {
    if (employeeProfileUiid) {
       const filter={ "employeeId" : { "type": "NONE", "value": employeeProfileUiid } }
      dispatch(
           totalCountStart({
             collection: "visas",
             coll: "Visa",
             tname: "cevisa",
              filters:filter,
           })
         );
         dispatch(
           getCurrentEmployeeImmigration({
             coll: "Visa",
             rsn: "visa",
             limit,
             page,
             ref:"Employee Document",
             incl:["uiid firstName"],
              filter,
           })
         );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch,page, limit]);
  const mappedRows = mapTableRows(lcaTableData, columns);
  return (
    <div>
      <TableAdv
        tableId={`employee_workauthorization_visa`}
        rows={mappedRows}
        columns={columns}
        serverPagination={true}
        totalCount={totalCount}
        // toolbarRight={[{ hideToolbar: true }]}
         page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
      />
      <Modal
        isOpen={documentModal}
        onClose={() => setDocumentModal(false)}
        title="Document Details"
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
       <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Visa;
